import PropTypes from 'prop-types';
import React from 'react';

import ButtonUserBar from '../ButtonUserBar';
import IconUserBar from '../IconUserBar';
import {InputUser} from '../InputUser';

const Form = (props) => {
  return (
    <form onSubmit={props.onSubmit} data-testid={props.dataTestId}>
      <div className="user-bar-group-2">
        <IconUserBar />
        <InputUser
          valueType={props.valueFlow}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          disabled={props.blockInput}
        />
        <ButtonUserBar />
      </div>
    </form>
  );
};

Form.propTypes = {
  onSubmit: PropTypes.func,
  valueFlow: PropTypes.string,
  value: PropTypes.string,
  dataTestId: PropTypes.string,
  onChange: PropTypes.func,
  blockInput: PropTypes.bool
};

export default Form;
